export default
{
  ask_base_api: {
    url: `${process.env.VUE_APP_ASK_API_URL}/api`
  },
  ask_api: {
    url: `${process.env.VUE_APP_ASK_API_URL}/api/ask/v1`
  },
  ask_pratiche_api: {
    url: `${process.env.VUE_APP_ASK_PRATICHE_URL}/api/ask/v1`
  },
  ask_flussi_api: {
    url: `${process.env.VUE_APP_ASK_FLUSSI_URL}/api/ask/v1`
  },
  ask_base_flussi: {
    url: `${process.env.VUE_APP_ASK_FLUSSI_URL}/api`
  },
  ask_pratiche: {
    url: `${process.env.VUE_APP_ASK_PRATICHE_URL}/api/pratiche/v1`
  },
  ask_backend: {
    url: `${process.env.VUE_APP_ASK_BACKEND_URL}/api/pratiche/v1`
  },
  ask_pratiche_scraper: {
    url: `${process.env.VUE_APP_ASK_PRATICHE_URL}/api/scraper/v1/acquirente-unico`
  },
  ask_pratiche_base: {
    url: process.env.VUE_APP_ASK_PRATICHE_URL
  },
  ask_call_api:{
    url: `${process.env.VUE_APP_ASK_CALL_URL}/api/voxloud`
  },
  ask_mail: {
    url: process.env.VUE_APP_ASK_MAIL_URL || 'https://mail.askmanagement.it'
  }
}
